import { useSuspenseQuery } from '@apollo/client/react';
import { GetStandorteForManagerDocument } from '../../gql/graphql';
import { Standort } from './entities/Standort';
import { Lohnabrechnungseinstellungen } from './entities/Lohnabrechnungseinstellungen';

export function useStandort(standortId: string): {
  standort?: Standort;
  error?: string;
} {
  const result = useSuspenseQuery(GetStandorteForManagerDocument);

  if (result.data.manager.__typename === 'ManagerError') {
    return { error: result.data.manager.message };
  }
  const standort = result.data.manager.standorte.find(
    (s) => s.uid === standortId,
  );

  if (!standort) {
    return { error: 'Standort not found' };
  }
  return {
    standort: new Standort({
      uid: standort.uid,
      name: standort.name,
      storenummer: standort.storeNummer,
      lohnabrechnungseinstellungen: new Lohnabrechnungseinstellungen({
        beraternummer: standort.lohnabrechnungseinstellungen.beraternummer,
        mandantennummer: standort.lohnabrechnungseinstellungen.mandantennummer,
        lohnabrechnungsart:
          standort.lohnabrechnungseinstellungen.lohnabrechnungsart,
      }),
    }),
  };
}
